/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiRejectRoomInvitationRequestFromJSON(json) {
    return StreemApiRejectRoomInvitationRequestFromJSONTyped(json, false);
}
export function StreemApiRejectRoomInvitationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rejectedByUserSid': !exists(json, 'rejected_by_user_sid') ? undefined : json['rejected_by_user_sid'],
    };
}
export function StreemApiRejectRoomInvitationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rejected_by_user_sid': value.rejectedByUserSid,
    };
}
//# sourceMappingURL=StreemApiRejectRoomInvitationRequest.js.map